var map = {
	"./ISO22000Certificate.png": 1978,
	"./ISO9001Certificate.png": 9383,
	"./ar.png": 8462,
	"./content-img.png": 1385,
	"./en.png": 260,
	"./helalCertificate.png": 8798,
	"./logo.png": 6949,
	"./rus.png": 1861,
	"./tr.png": 2800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;